module.exports = __webpack_public_path__ + "img/bottom-arrow.ace027ac.png";